<template>
  <div class="exchange">
    <el-dialog
      v-loading="loading"
      title="选择退换货原因"
      :visible.sync="DialogVisible"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-radio-group v-model="type" @input="radioChange">
        <el-row :gutter="26">
          <el-col :span="8">
            <el-radio :label="1">
              市场销售原因
            </el-radio>
          </el-col>
          <el-col :span="8">
            <el-radio :label="2">
              产品缺货或停产
            </el-radio>
          </el-col>
          <el-col :span="8">
            <el-radio :label="3">
              其他原因
            </el-radio>
          </el-col>
        </el-row>
        <el-row :gutter="26">
          <!-- <el-col :span="8">
            <el-radio :label="4">
              其他原因-税率原因
            </el-radio>
          </el-col> -->
          <el-col :span="8">
            <el-radio :label="5">
              亚马逊海外专用
            </el-radio>
          </el-col>
          <el-col :span="8">
            <el-radio :label="6">
              产品功能问题
            </el-radio>
          </el-col>
        </el-row>
      </el-radio-group>
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="DialogVisible = false">
          取消
        </el-button>
        <el-button type="primary" @click="submit"> 确定 </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getOverseasExContractNumByNewNum } from '@/API';
export default {
  data () {
    return {
      DialogVisible: false,
      type: 1, // 退换货原因 radio
      reasonText: 'salesReason',
      data: {},
      loading: false,
      serialNum: '',
      serialNumXn: '',
      orderUnitCode: '', // 订货单位编码
      overseasRateToUsd: '', // 转美元汇率
      overseasRate: '', // 美元转合同上币种汇率
      partnerType: ''
    };
  },
  components: {},
  methods: {
    radioChange (val) {
      this.type = val;
      this.getReasonType(val);
    },
    /**
     *
     * 四种类型:
     *    对应的传type="xxx"
          销售原因  -> salesReason
          产品原因  -> productReason
          特殊原因  -> specialReason
          齐套不提货撤单 -> completeSetWithoutDelivery
          产品功能问题  -> productFuntionalIssues
     */
    showExchangeDialog (row) {
      this.data = row;
      this.DialogVisible = true;
      this.getData();
    },
    // 根据radio的值，返回对应的字段
    getReasonType (type) {
      const reasonMapping = {
        1: 'salesReason',
        2: 'productReason',
        3: 'specialReason',
        4: 'specialReasonTaxRate',
        5: 'completeSetWithoutDelivery',
        6: 'productFuntionalIssues'
      };

      if (reasonMapping.hasOwnProperty(type)) {
        this.reasonText = reasonMapping[type];
      } else {
        this.reasonText = '';
      }
    },
    symbolChange (string, targetChar, replacementChar) {
      // 个别数据有#符号 #会带到路由中 变成锚点阻塞，暂时只处理一个#符
      let regex = new RegExp(targetChar, 'g');
      const temp = this.emptyChange(string);
      let resultStr = temp.replace(regex, replacementChar);
      return resultStr;
    },
    emptyChange (val) {
      if (val == null) {
        return '';
      }
      return val;
    },
    getData () {
      getOverseasExContractNumByNewNum({
        newNum: this.data.contractNum
      }).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.serialNum = this.emptyChange(json.data.serialNum);
          this.serialNumXn = this.emptyChange(json.data.serialNumXn);
          this.orderUnitCode = this.symbolChange(json.data.orderUnitCode ?? '', '#', '@3523@');
          this.overseasRateToUsd = this.emptyChange(json.data.overseasRateToUsd);
          this.overseasRate = this.emptyChange(json.data.overseasRate);
          this.partnerType = this.symbolChange(json.data.partnerType ?? '', '#', '@3523@');
        }
      }).catch(() => {

      }).finally(() => {
        this.loading = false;
      });
    },
    submit () {
      let Base64 = require('js-base64').Base64;
      let loginType = localStorage.getItem('loginType');
      let orderUrl = `/ibsReturnExchange/ibsCreateReturnExchangeRequest?partnerType=${this.partnerType}&orderUnitCode=${this.orderUnitCode}&overseasRateToUsd=${this.overseasRateToUsd}&overseasRate=${this.overseasRate}&type=${this.reasonText}&customerPoNum=${this.data.contractNum || ''}&serialNum=${this.serialNum}&serialNumXn=${this.serialNumXn}`;
      // /ibsReturnExchange/ibsCreateReturnExchangeRequest?partnerType=VAD Partner&orderUnit=ZARNI Aung and Sons Trading Co., Ltd.&overseasRateToUsd=1&overseasRate=1&type=completeSetWithoutDelivery&customerPoNum=101224060300300&serialNum=&serialNumXn=101224060300300
      let url = Base64.encode(orderUrl);
      let returnExchangePath = '';
      let sidUrl = `https://sid.ruijie.com.cn/`;
      if (loginType) {
        if (window._env_.NODE_ENV === 'pro') {
          returnExchangePath = `${sidUrl}channel/login?service=${encodeURIComponent(`https://rjop.ruijie.com.cn/login?route=${url}&loginType=${loginType}`)}`;
        } else if (window._env_.NODE_ENV === 'test') {
          returnExchangePath = `${sidUrl}channel/login?service=${encodeURIComponent(`https://order-platform-test.ruijie.com.cn/login?route=${url}&loginType=${loginType}`)}`;
        } else if (window._env_.NODE_ENV === 'uat') {
          returnExchangePath = `${sidUrl}channel/login?service=${encodeURIComponent(`https://order-platform-uat.ruijie.com.cn/login?loginType=${loginType}&route=${url}`)}`;
        } else {
          returnExchangePath = `http://order-platform-uat.ruijie.com.cn${orderUrl}`;
        }
      } else {
        if (window._env_.NODE_ENV === 'pro') {
          returnExchangePath = `${sidUrl}login?service=http://rjop.ruijie.com.cn/login?route=${url}`;
        } else if (window._env_.NODE_ENV === 'test') {
          returnExchangePath = `${sidUrl}login?service=http://order-platform-test.ruijie.com.cn/login?route=${url}`;
        } else if (window._env_.NODE_ENV === 'uat') {
          returnExchangePath = `${sidUrl}login?service=http://order-platform-uat.ruijie.com.cn/login?route=${url}`;
        } else {
          returnExchangePath = `http://order-platform-uat.ruijie.com.cn${orderUrl}`;
        }
      }
      this.DialogVisible = false;
      window.location.href = returnExchangePath;
    }
  }
};
</script>
<style lang="scss" scoped>
.exchange {
  ::v-deep .el-dialog__wrapper {
    .el-dialog__body {
      text-align: center;
    }
  }
}
</style>
